const images = {
    logo: require('../assets/images/logo-01-02-01-01.svg').default,
    avt: require('../assets/images/logo-for-react-512-01.png')
}

export default images